import React from "react";
import "./styles.scss";

const ClearButton = ({
  handleClick,
  dataQa,
}: {
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  dataQa: string;
}) => {
  return (
    <button
      className="clearDate"
      type="reset"
      onClick={handleClick}
      aria-label="Clear Date"
      data-qa={dataQa}>
      <svg
        className="clearDate-svg"
        focusable="false"
        viewBox="0 0 12 12">
        <path
          fillRule="evenodd"
          d="M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"></path>
      </svg>
    </button>
  );
};

export default ClearButton;
